﻿
myApp.controller("aboutCtrl", ['$scope', '$http', function ($scope, $http) {
    $scope.setPage("about");//navbar action
    $scope.setPageClass("yit-about");

    $scope.AllStrings = {
        story: {

        },
        values: {
            h2:"",
            value:[]
        }
    }
    var win = $(window);

    var story = $(".story");
    var storyimg = $(".story-img");

    win.scroll(function (event) {
        story.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                el.addClass("fadeup");
            }
        });

        storyimg.each(function (i, el) {
            var el = $(el);
            if (el.visible(true)) {
                // el.addClass("storyimg");
            }
        });

    });

    $scope.WaitForStrings(function () {

        var xml = this.strings;
        var about = $(xml).find("about");
        $scope.h1 = $(about).find("h1").find($scope.lang).html().trim();
        $scope.AllStrings.title = $(about).find("title").find($scope.lang).html().trim();
        //story
        $scope.AllStrings.story.h2 = $(about).find("story").find("h2").find($scope.lang).text().trim();
        $scope.AllStrings.story.p1 = $(about).find("story").find("p1").find($scope.lang).text().trim();
        $scope.AllStrings.story.p2 = $(about).find("story").find("p2").find($scope.lang).text().trim();


        $scope.AllStrings.values.h2 = $(about).find("values").find("h2").find($scope.lang).text().trim();
        var values = $(about).find("values").find("value");

        values.each(function () {
            var h = $(this).find("h").find($scope.lang).text().trim();
            var p = $(this).find("b").find($scope.lang).text().trim();
            $scope.AllStrings.values.value.push({
                h: h,
                p:p
            })
        });


        $scope.setTitle($scope.AllStrings.title);//set title to the page

    }.bind($scope));

}]);



//////////////////
// WEBPACK FOOTER
// ../scripts/yit/pages/about.js
// module id = 18
// module chunks = 0